(function () {
    'use strict';

    // @ngInject
    Services.Maxmind = function Maxmind($window, ThirdPartyLoaderService) {
        return ThirdPartyLoaderService.loadUrlPromise('https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js', function() {return $window.geoip2;});
    };

}());